<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-revert`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.172 12H40v28H9V24H5v18a2 2 0 002 2h35a2 2 0 002-2V10a2 2 0 00-2-2H11.172l2.95-2.95a1 1 0 000-1.414l-1.415-1.414a1 1 0 00-1.414 0l-7.071 7.07a1 1 0 000 1.415l7.07 7.071a1 1 0 001.415 0l1.414-1.414a1 1 0 000-1.414L11.171 12z"/></svg>
</template>
<script>

export default {
  name: 'IconRevert',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
